var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-action-button',{attrs:{"icon":"mdi-clipboard-list","label":_vm.$t('integrations.fields.show_logs'),"text":""},on:{"click":function($event){return _vm.showLog(_vm.item)}}})}
var staticRenderFns = []

export { render, staticRenderFns }